// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetMultipleExperimentRequest,
  TGetMultipleExperimentModel,
  IMappers,
  TGetMultipleExperimentResponse,
  IGetMultipleExperimentResponse,
  IGetMultipleExperimentResponseError,
} from './types';

export const defaultConfig: TGetMultipleExperimentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'ab-use',
  pathApi: '/v1/get-multiple-experiment/',
  requestType: 'json',
} as TGetMultipleExperimentModel;

export function createGetMultipleExperimentModel(
  parameters: IGetMultipleExperimentRequest,
): TGetMultipleExperimentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMultipleExperimentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMultipleExperimentRequest;
}

export async function fetchGetMultipleExperiment<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMultipleExperimentOptions<TResponse200, TResponse400>): Promise<
  TGetMultipleExperimentResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetMultipleExperimentModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMultipleExperimentResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetMultipleExperimentResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetMultipleExperimentResponse;
}
